import api from './api';

// Admin interface for reading (includes all fields from backend)
export interface Admin {
  id: string;
  schoolId: string;
  userName: string;
  profileId?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  enabled?: boolean;
  creationDatetime?: string;
  lastAuthenticationDatetime?: string;
}

// Admin input for create/update (excludes read-only fields, includes password)
export interface AdminInput {
  userName: string;
  profileId?: string;
  password?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  enabled?: boolean;
}

export const adminService = {
  getAllAdmins: async (): Promise<Admin[]> => {
    const response = await api.get<Admin[]>('/{schoolId}/admins');
    return response.data;
  },

  getAdminById: async (id: string): Promise<Admin> => {
    const response = await api.get<Admin>(`/{schoolId}/admins/${id}`);
    return response.data;
  },

  createAdmin: async (admin: AdminInput): Promise<Admin> => {
    const response = await api.post<Admin>('/{schoolId}/admins', admin);
    return response.data;
  },

  updateAdmin: async (id: string, admin: AdminInput): Promise<Admin> => {
    const response = await api.put<Admin>(`/{schoolId}/admins/${id}`, admin);
    return response.data;
  },

  deleteAdmin: async (id: string): Promise<void> => {
    await api.delete(`/{schoolId}/admins/${id}`);
  },
};

